import { render, staticRenderFns } from "./crudPriceListSuppliers.vue?vue&type=template&id=6429ece2&"
import script from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
export * from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./crudPriceListSuppliers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports